/* Ordinia — barra fija de compra (móvil). La aparición al hacer scroll está en ordinia-reveal.js.
   Sin dependencias. Si algo falla, el contenido sigue visible. */
(function () {
  if (window.__ordiniaSections) return;
  window.__ordiniaSections = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSticky(root) {
    var bar = (root || document).querySelector('[data-ord-sticky]:not([data-ord-ready])');
    if (!bar) return;
    bar.setAttribute('data-ord-ready', '');

    var productId = bar.getAttribute('data-product-id');
    var button = bar.querySelector('[data-ord-sticky-button]');
    var priceNow = bar.querySelector('[data-ord-sticky-price]');
    var priceWas = bar.querySelector('[data-ord-sticky-was]');
    var variants = {};
    try { variants = JSON.parse(bar.querySelector('script[type="application/json"]').textContent); } catch (e) {}

    function mainForm() {
      return document.querySelector('product-form-component[data-product-id="' + productId + '"]');
    }
    function mainButton() {
      var form = mainForm();
      return form && form.querySelector('button[name="add"]');
    }

    // El botón de la barra pulsa el botón principal: misma variante, misma cantidad y mismo carrito.
    button.addEventListener('click', function () {
      var main = mainButton();
      if (main && !main.disabled) {
        main.click();
      } else if (mainForm()) {
        mainForm().scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      }
    });

    // La barra aparece mientras el botón principal no está en pantalla
    // (por encima, tras pasarlo, o por debajo, antes de llegar a él).
    function updateBar() {
      var target = mainButton() || mainForm();
      if (!target) return;
      var r = target.getBoundingClientRect();
      bar.classList.toggle('is-visible', r.bottom < 0 || r.top > window.innerHeight);
    }
    window.addEventListener('scroll', updateBar, { passive: true });
    window.addEventListener('resize', updateBar, { passive: true });
    updateBar();

    // Precio y disponibilidad siguen a la variante elegida.
    document.addEventListener('variant:update', function (event) {
      var resource = event.detail && event.detail.resource;
      var data = resource && variants[String(resource.id)];
      if (!data) return;
      if (priceNow) priceNow.textContent = data.price;
      if (priceWas) {
        priceWas.textContent = data.compare || '';
        priceWas.hidden = !data.compare;
      }
      button.disabled = !data.available;
      var label = button.querySelector('[data-ord-sticky-label]');
      if (label) label.textContent = data.available ? button.getAttribute('data-label-add') : button.getAttribute('data-label-soldout');
    });
  }

  function init(root) { initSticky(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Editor de temas: al recargar una sección, la volvemos a preparar.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
